// extracted by mini-css-extract-plugin
module.exports = {"button":"FloatingEditButton_button__sIg7x","container":"FloatingEditButton_container__hqSQu"};